import React, { Fragment } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import "./HeroForm.css";
import Fade from "react-reveal/Fade";
import { Dimensions } from '../../Helper/sitedimension';
import MainImg from './grimg.png';

const HeroFormUI = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <div className="wr-content heroform">
      <div className="container-fluid">
        <div className="row">
          {width > 500 ?
            (<Fragment><div className="col-7 l-bgimg"></div>
              <div className="col-5">
                <h2 className="title-style">
                  <Fade delay={300}>Please Enter Your Details</Fade>
                </h2>
                <br />
                <Fade delay={500}>
                  <Form>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formGridName">
                        <Form.Label className="text-muted">
                          Name<span className="reqd">(*)</span>
                        </Form.Label>
                        <Form.Control type="name" placeholder="" />
                      </Form.Group>

                      <Form.Group as={Col} controlId="formGridPhone">
                        <Form.Label className="text-muted">
                          Contact No.<span className="reqd">(*)</span>
                        </Form.Label>
                        <Form.Control type="phone" placeholder="" />
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group as={Col} controlId="formGridCompany">
                        <Form.Label className="text-muted">
                          Company<span className="reqd">(*)</span>
                        </Form.Label>
                        <Form.Control type="company " placeholder="" />
                      </Form.Group>

                      <Form.Group as={Col} controlId="formGridJobTitle">
                        <Form.Label className="text-muted">
                          Job Title<span className="reqd">(*)</span>
                        </Form.Label>
                        <Form.Control
                          type="jobtitle"
                          placeholder=""
                        />
                      </Form.Group>
                    </Form.Row>

                    <Form.Group controlId="formGridEmail">
                      <Form.Label className="text-muted">
                        E-Mail<span className="reqd">(*)</span>
                      </Form.Label>
                      <Form.Control placeholder="" />
                    </Form.Group>

                    <Form.Group controlId="exampleForm.ControlTextarea1">
                      <Form.Label className="text-muted">Message</Form.Label>
                      <Form.Control as="textarea" rows="5" />
                    </Form.Group>
                  </Form>
                </Fade>
                <Fade delay={800}>
                  <button className="thbtn">
                    <span className="btncon">Submit</span>
                  </button>
                </Fade>
              </div></Fragment>) : (
              <Fragment>
                <div style={{ overflow: "hidden" }}>
                  <img src={MainImg} className="temp-img" alt="background" />
                  <div className="col-12 container">
                    <h2 className="title-style" style={{ fontSize: "30px" }}>
                      <Fade delay={300}>Please Enter Your Details</Fade>
                    </h2>
                    <br />
                    <Fade delay={500}>
                      <Form>
                        <Form.Row>
                          <Form.Group as={Col} controlId="formGridName">
                            <Form.Label className="text-muted">
                              Name<span className="reqd">(*)</span>
                            </Form.Label>
                            <Form.Control type="name" placeholder="" />
                          </Form.Group>

                          <Form.Group as={Col} controlId="formGridPhone">
                            <Form.Label className="text-muted">
                              Contact No.<span className="reqd">(*)</span>
                            </Form.Label>
                            <Form.Control type="phone" placeholder="" />
                          </Form.Group>
                        </Form.Row>

                        <Form.Row>
                          <Form.Group as={Col} controlId="formGridCompany">
                            <Form.Label className="text-muted">
                              Company<span className="reqd">(*)</span>
                            </Form.Label>
                            <Form.Control type="company " placeholder="" />
                          </Form.Group>

                          <Form.Group as={Col} controlId="formGridJobTitle">
                            <Form.Label className="text-muted">
                              Job Title<span className="reqd">(*)</span>
                            </Form.Label>
                            <Form.Control
                              type="jobtitle"
                              placeholder=""
                            />
                          </Form.Group>
                        </Form.Row>

                        <Form.Group controlId="formGridEmail">
                          <Form.Label className="text-muted">
                            E-Mail<span className="reqd">(*)</span>
                          </Form.Label>
                          <Form.Control placeholder="" />
                        </Form.Group>

                        <Form.Group controlId="exampleForm.ControlTextarea1">
                          <Form.Label className="text-muted">Message</Form.Label>
                          <Form.Control as="textarea" rows="5" />
                        </Form.Group>
                      </Form>
                    </Fade>
                    <Fade delay={800}>
                      <button className="thbtn">
                        <span className="btncon">Submit</span>
                      </button>
                    </Fade>
                  </div>
                </div>
              </Fragment>
            )}
        </div>
      </div>
    </div>
  );
};

export default HeroFormUI;
